import * as yup from 'yup'
import { INVALID_MANAGEMENT_FEE_VALUE, REQUIRED_FIELD } from 'constants/errors'
import { managementFeeReg } from 'constants/regExp'

export const setManagementFeeSchema = yup.object().shape({
  feeValue: yup.string().required(REQUIRED_FIELD).matches(managementFeeReg, INVALID_MANAGEMENT_FEE_VALUE),
})
